import { defineComponent as _defineComponent } from 'vue'
import CButton from '@/components/shared/CButton';


export default /*#__PURE__*/_defineComponent({
  __name: 'ColorOptionsClipboardButtons',
  props: {
    title: null,
    canCopy: { type: Boolean },
    canPaste: { type: Boolean }
  },
  emits: ["copy", "paste"],
  setup(__props: any) {

const props = __props as {
    /** Section heading (Fill's "Fill", Shadow's "Color"...). */
    title: string;
    canCopy: boolean;
    canPaste: boolean;
};

/**
 * The Copy/Paste header row shared by every color-options section (Fill, Stroke, Shadow, Vector
 *  single color): a title plus two icon buttons. What copying and pasting actually do stays with
 *  each section - field names, gradient blocking, auto-enabling a disabled effect all differ enough
 *  per section that folding them in here would just move callbacks around instead of removing them.
 */




return { __sfc: true,props, CButton }
}

})